// This is a manifest file that'll be compiled into application.js, which will include all the files
// listed below.
//
// Any JavaScript/Coffee file within this directory, lib/assets/javascripts, or any plugin's
// vendor/assets/javascripts directory can be referenced here using a relative path.
//
// It's not advisable to add code directly here, but if you do, it'll appear at the bottom of the
// compiled file. JavaScript code in this file should be added after the last require_* statement.
//
// Read Sprockets README (https://github.com/rails/sprockets#sprockets-directives) for details
// about supported directives.
//
//= require_tree .

// app/javascript/packs/application.js
import Rails from "@rails/ujs"
// Solo inicializar si no está ya inicializado
// Verificar si Rails ya está inicializado usando una bandera global
if (!window.RailsUJSInitialized) {
  try {
    Rails.start()
    window.RailsUJSInitialized = true
  } catch (error) {
    // Si ya está inicializado, rails-ujs lanzará un error
    // En ese caso, marcamos como inicializado para evitar futuros intentos
    if (error.message && error.message.includes('already been loaded')) {
      window.RailsUJSInitialized = true
    } else {
      console.error('Error initializing Rails UJS:', error)
    }
  }
}

import "@hotwired/turbo-rails"
import "../channels"

import "controllers"
import "bootstrap"
import "slim-select"
import "chartkick"
import Chart from 'chart.js'

// Formato es-AR global para TODOS los charts de chartkick: separador de miles
// en tooltips y eje Y ("81529000" → "81.529.000"). El helper de chartkick no
// puede pasar callbacks (serializa a JSON), así que va como default global acá.
// OJO: la app usa Chart.js 2.9.4 → sintaxis v2 (yAxes array + tooltips, NO
// plugins.tooltip). Los charts con `library` propio pisan estos defaults.
if (window.Chartkick) {
  const fmtMiles = (v) => Number(v).toLocaleString("es-AR", { maximumFractionDigits: 2 })
  window.Chartkick.options = {
    library: {
      scales: { yAxes: [{ ticks: { callback: (v) => fmtMiles(v) } }] },
      tooltips: {
        callbacks: {
          label: (item, data) => {
            const ds = data.datasets && data.datasets[item.datasetIndex]
            const lbl = ds && ds.label ? ds.label + ": " : ""
            const val = item.yLabel !== undefined && item.yLabel !== null ? item.yLabel : item.value
            return lbl + fmtMiles(val)
          }
        }
      }
    }
  }
}
import "choices.js"
import "flatpickr"
import "jquery"
import "lodash"
// Mapbox is loaded via CDN in application.html.erb to avoid compilation issues
// import "mapbox-gl"
// import "mapbox-gl/dist/mapbox-gl.css"
import "sortablejs"
import "trix"
